import React, { ReactNode } from 'react';
// Styles
import styles from './roundbutton.module.scss';

interface IRoundButtonProps {
    id: string;
    children: ReactNode;
    onClick?: (event?: React.MouseEvent) => void;
    onPointerDown?: (event?: React.MouseEvent | React.TouchEvent) => void;
    onBlur?: (event?: React.FocusEvent) => void;
    onKeyDown?: (event: React.KeyboardEvent) => void;
    isHoverable?: boolean;
    disabled?: boolean;
    className?: string;
    ariaLabel?: string;
    tabIndex?: number;
}

export const RoundButton = ({
    id,
    children,
    onClick,
    onPointerDown,
    onBlur,
    onKeyDown,
    isHoverable,
    disabled = false,
    className = '',
    tabIndex,
    ariaLabel,
}: IRoundButtonProps): JSX.Element => {
    return (
        <button
            id={id}
            onClick={onClick}
            onBlur={onBlur}
            onKeyDown={onKeyDown}
            onPointerDown={onPointerDown}
            tabIndex={tabIndex}
            disabled={disabled}
            className={[className, styles.roundbutton, isHoverable ? styles.hoverable : ''].join(' ')}
            {...(ariaLabel && { 'aria-label': ariaLabel })}
        >
            {children}
        </button>
    );
};
